import React from "react";
import classNames from './ProductName.module.css';

export const ProductName = () => (
	<span className={classNames.ProductNameSpan}>My Data Go <span className={classNames.ProductNameWhereSpan}>Where?!</span></span>);
